// Reservation Step Constants
export const RESERVATION_STEPS = [
  {
    label: 'Service',
    icon: 'restaurant',
  },
  {
    label: 'Convives',
    icon: 'people',
  },
  {
    label: 'Date',
    icon: 'calendar',
  },
  {
    label: 'Horaire',
    icon: 'time',
  },
  {
    label: 'Coordonnées',
    icon: 'contact',
  },
];

// Availability indicators
export const AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  LIMITED: 'limited',
  BUSY: 'busy',
  UNAVAILABLE: 'unavailable',
  CLOSED: 'closed',
  SELECTED: 'selected',
};

// Service types
export const SERVICE_TYPES = {
  LUNCH: 'midi',
  DINNER: 'soir',
};

// Error messages
export const ERROR_MESSAGES = {
  SERVICE_REQUIRED: 'Veuillez sélectionner un service',
  PARTY_SIZE_MIN: (min) => `Le nombre minimum de convives est de ${min} personnes`,
  PARTY_SIZE_MAX: (max) => `Le nombre maximum de convives est de ${max} personnes`,
  DATE_REQUIRED: 'Veuillez sélectionner une date',
  TIME_REQUIRED: 'Veuillez sélectionner un créneau horaire',
  FIRST_NAME_REQUIRED: 'Le prénom est requis',
  LAST_NAME_REQUIRED: 'Le nom est requis',
  EMAIL_REQUIRED: 'L\'email est requis',
  EMAIL_INVALID: 'Veuillez entrer une adresse email valide (ex: nom@domaine.com)',
  EMAIL_INVALID_FORMAT: 'L\'adresse email doit inclure un domaine valide (ex: .com, .fr)',
  PHONE_REQUIRED: 'Le numéro de téléphone est requis',
  PHONE_INVALID: 'Veuillez entrer un numéro de téléphone valide',
  MINIMUM_NOTICE: (hours) => `Les réservations doivent être faites au moins ${hours} heures à l'avance`,
  MAXIMUM_ADVANCE: (days) => `Les réservations sont possibles jusqu'à ${days} jours à l'avance`,
  NO_AVAILABILITY: 'Aucun créneau disponible pour cette date',
  GENERAL_ERROR: 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
};

// Widget Configuration Errors
export const CONFIG_ERROR_TYPES = {
  MISSING_COMPANY_ID: 'MISSING_COMPANY_ID',
  MISSING_API_KEY: 'MISSING_API_KEY',
  MISSING_BOTH: 'MISSING_BOTH',
  INVALID_CONFIG: 'INVALID_CONFIG',
};

export const CONFIG_ERROR_MESSAGES = {
  [CONFIG_ERROR_TYPES.MISSING_COMPANY_ID]: {
    title: 'ID du restaurant manquant',
    message: 'L\'ID du restaurant n\'est pas spécifié.',
    details: 'Veuillez fournir un ID de restaurant valide.',
  },
  [CONFIG_ERROR_TYPES.MISSING_API_KEY]: {
    title: 'Clé API manquante',
    message: 'La clé API n\'est pas spécifiée.',
    details: 'Veuillez fournir une clé API valide.',
  },
  [CONFIG_ERROR_TYPES.MISSING_BOTH]: {
    title: 'Paramètres manquants',
    message: 'L\'ID du restaurant et la clé API sont manquants.',
    details: 'Ces informations sont nécessaires pour afficher le widget de réservation.',
  },
  [CONFIG_ERROR_TYPES.INVALID_CONFIG]: {
    title: 'Configuration incorrecte',
    message: 'Impossible de charger la configuration du restaurant.',
    details: 'Veuillez vérifier que l\'ID du restaurant et la clé API sont corrects.',
  },
};

// Date format options
export const DATE_FORMAT_OPTIONS = {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
};

// Time format
export const TIME_FORMAT = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};
